import React from "react";
import { classNames } from "Utils/utils";
import "./CareWatchNewBadge.css";

/**
 * White "NEW" chip for the Care Watch nav row (web SPA only — not Flutter).
 * Gradient border + lit glow + periodic tickle animation.
 */
const CareWatchNewBadge = ({ size = "sidebar" }) => {
  const isDrawer = size === "drawer";

  return (
    <span
      className={classNames(
        "care-watch-new-badge",
        isDrawer ? "care-watch-new-badge--drawer" : "care-watch-new-badge--sidebar"
      )}
      aria-label="New feature"
    >
      NEW
    </span>
  );
};

export default CareWatchNewBadge;
